import Carousel from '../../../components/carousel';

function initCarousels() {
	const carouselItems = document.querySelectorAll('.c-carousel');

	if (carouselItems.length > 0) {
		Carousel();
	}
}

export default initCarousels;
